import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface SuggestionChip {
  i18nKey: string;
  promptI18nKey: string;
}

@Component({
  selector: 'app-chat-suggestions',
  templateUrl: './chat-suggestions.component.html',
  styleUrls: ['./chat-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatSuggestionsComponent {
  @Output() readonly pick = new EventEmitter<string>();
  @Output() readonly navigate = new EventEmitter<string>();

  readonly chips: ReadonlyArray<SuggestionChip> = [
    { i18nKey: 'chatAi.suggestions.pendingReception.label',
      promptI18nKey: 'chatAi.suggestions.pendingReception.prompt' },
    { i18nKey: 'chatAi.suggestions.stuckInWorkshop.label',
      promptI18nKey: 'chatAi.suggestions.stuckInWorkshop.prompt' },
    { i18nKey: 'chatAi.suggestions.criticalStock.label',
      promptI18nKey: 'chatAi.suggestions.criticalStock.prompt' },
    { i18nKey: 'chatAi.suggestions.todayAppointments.label',
      promptI18nKey: 'chatAi.suggestions.todayAppointments.prompt' },
    { i18nKey: 'chatAi.suggestions.pendingBudgets.label',
      promptI18nKey: 'chatAi.suggestions.pendingBudgets.prompt' },
    { i18nKey: 'chatAi.suggestions.inactiveClients.label',
      promptI18nKey: 'chatAi.suggestions.inactiveClients.prompt' },
    { i18nKey: 'chatAi.suggestions.weeklyOrders.label',
      promptI18nKey: 'chatAi.suggestions.weeklyOrders.prompt' },
    { i18nKey: 'chatAi.suggestions.workshopKpis.label',
      promptI18nKey: 'chatAi.suggestions.workshopKpis.prompt' },
  ];

  constructor(private readonly translate: TranslateService) {}

  trackByIndex(index: number): number { return index; }

  onPick(promptI18nKey: string): void {
    const prompt = this.translate.instant(promptI18nKey) as string;
    this.pick.emit(prompt);
  }

  onNavigate(route: string): void {
    this.navigate.emit(route);
  }
}
